export function isArabic(text) {
  if (!text || typeof text !== "string") return false; // Handle empty or invalid input

  const arabicRegex = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]/;

  return arabicRegex.test(text); // Returns true if any Arabic character is found
}
